module.exports = "/_next/static/images/parallax-7-e2f84dc12846893223f44b06f9fb2267.jpg.webp";